import { AttemptAndUserIdData, CartViewedData, CheckoutStartedData, CheckoutStepCompletedData, GoogleDataLayerEvents, PageLoadedData, PaymentInfoEnteredData, ShippingInfoEnteredData, ProductAndCurrencyData, OrderCompletedData, ProductsSearchedData, RemindMeData, PageErrorData } from "./types";

// Wrap the event push logic with a retry mechanism
const pushEventWithRetry = (eventName, eventData, maxAttempts = 3) => {
  let attempts = 0;

  const intervalEvent = () => {
    attempts++;

    if (typeof window !== 'undefined' && window["dataLayer"] !== undefined) {
      // Clear the interval on success
      clearInterval(intervalId);

      // Push the event to the dataLayer
      window["dataLayer"].push({ event: eventName, ecommerce: eventData });
    }

    // Check if the maximum number of attempts is reached
    if (attempts >= maxAttempts) {
      clearInterval(intervalId);
    }
  }

  const intervalId = setInterval(intervalEvent, 1000); // Retry every 1 second
  intervalEvent()
}

export default {
  pageLoaded(pageLoadedData: PageLoadedData) {
    pushEventWithRetry(GoogleDataLayerEvents.PAGE_LOADED, pageLoadedData);
  },

  signUp(signUpData: AttemptAndUserIdData) {
    pushEventWithRetry(GoogleDataLayerEvents.SIGN_UP, signUpData);
  },
  login(loginData: AttemptAndUserIdData) {
    pushEventWithRetry(GoogleDataLayerEvents.LOGIN, loginData);
  },

  newsletterSubscribe(newsletterSubscribeData: AttemptAndUserIdData) {
    pushEventWithRetry(GoogleDataLayerEvents.NEWSLETTER_SUBSCRIBED, newsletterSubscribeData);
  },

  updateCartItem(action: "add" | "remove", updateCartItemData: ProductAndCurrencyData) {
    pushEventWithRetry(
      action === 'remove' ?
        GoogleDataLayerEvents.REMOVE_FROM_CART :
        GoogleDataLayerEvents.ADD_TO_CART ,
      updateCartItemData
    );
  },

  viewCart(viewCartData: CartViewedData) {
    pushEventWithRetry(GoogleDataLayerEvents.VIEW_CART, viewCartData);
  },

  // CHECKOUT STARTED => SEND WHEN USER CLICKS ON "Continue to shipping information"
  beginCheckout(checkoutStartedData: CheckoutStartedData) {
    pushEventWithRetry(GoogleDataLayerEvents.BEGIN_CHECKOUT, checkoutStartedData);
  },

  // shipping_info_entered => SEND WHEN USER CLICKS ON "Go to billing information"
  addShippingInfo(addShippingInfoData: ShippingInfoEnteredData) {
    pushEventWithRetry(GoogleDataLayerEvents.ADD_SHIPPING_INFO, addShippingInfoData);
  },

  // payment_info_entered => SEND WHEN USER CLICKS ON "Continue to payment information"
  addPaymentInfo(addPaymentInfoData: PaymentInfoEnteredData) {
    pushEventWithRetry(GoogleDataLayerEvents.ADD_PAYMENT_INFO, addPaymentInfoData);
  },

  checkoutStepCompleted(checkoutStepCompletedData: CheckoutStepCompletedData) {
    pushEventWithRetry(GoogleDataLayerEvents.CHECKOUT_STEP_COMPLETED, checkoutStepCompletedData);
  },

  viewItem(productViewedData: ProductAndCurrencyData) {
    pushEventWithRetry(GoogleDataLayerEvents.VIEW_ITEM, productViewedData);
  },

  giftWrapped(action: GoogleDataLayerEvents.ADD_TO_CART | GoogleDataLayerEvents.REMOVE_FROM_CART, giftWrappedData: ProductAndCurrencyData) {
    pushEventWithRetry(action, giftWrappedData);
  },

  purchase(purchaseData: OrderCompletedData) {
    pushEventWithRetry(GoogleDataLayerEvents.PURCHASE, purchaseData);
  },

  search(searchData: ProductsSearchedData) {
    pushEventWithRetry(GoogleDataLayerEvents.SEARCH, searchData);
  },

  remindMe(remindMeData: RemindMeData) {
    pushEventWithRetry(GoogleDataLayerEvents.REMIND_ME, remindMeData);
  },

  pageError(pageErrorData: PageErrorData) {
    pushEventWithRetry(GoogleDataLayerEvents.PAGE_ERROR, pageErrorData);
  },
}
